import React from 'react';
import { FaPlus, FaCheck, FaExclamationCircle } from "react-icons/fa";
import Select from "react-select";
import Modal from "../../../../components/Utils/ModalShow";

const CreateAccountModal = ({ 
  isOpen,
  onClose,
  newAccountData,
  onCodeChange,
  onNameChange,
  onTypeChange,
  onReconcileChange,
  onCreateAccount,
  accountTypes,
  createLoading
}) => {
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#0C5B6D" : "#d1d5db",
      borderRadius: "0.5rem",
      padding: "0.125rem",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(12, 91, 109, 0.2)" : "none",
      "&:hover": { borderColor: "#0C5B6D" },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#0C5B6D" : state.isFocused ? "#F1F6FC" : "white",
      color: state.isSelected ? "white" : "#374151",
      padding: "0.75rem 1rem",
    }),
    placeholder: (provided) => ({ ...provided, color: "#9ca3af", fontSize: "0.875rem" }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  const modalFooter = (
    <>
      <button
        onClick={onClose}
        className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors"
        type="button"
      >
        Annuler
      </button>
      <button
        onClick={onCreateAccount}
        disabled={
          createLoading ||
          !newAccountData.code ||
          !newAccountData.name
        }
        className="px-4 py-2 bg-[--color-primary] text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
        type="button"
      >
        {createLoading ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
            Création...
          </>
        ) : (
          <>
            <FaCheck size={14} />
            Créer le compte
          </>
        )}
      </button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Créer un nouveau compte"
      headerIcon={<FaPlus className="text-[--color-primary]" size={20} />}
      footer={modalFooter}
    >
      <div className="p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Code comptable
          </label>
          <input
            type="text"
            value={newAccountData.code}
            onChange={onCodeChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[--color-primary]"
            placeholder="Ex: 661000"
            autoFocus
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nom du compte
          </label>
          <input
            type="text"
            value={newAccountData.name}
            onChange={onNameChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[--color-primary]"
            placeholder="Ex: Salaires et traitements"
          />
        </div>

        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Type de compte
          </label>
          <Select
            value={accountTypes.find(
              (type) => type.value === newAccountData.account_type
            )}
            onChange={onTypeChange}
            options={accountTypes}
            placeholder="Sélectionner un type..."
            isSearchable
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            menuPlacement="auto"
          />
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="reconcile"
            checked={newAccountData.reconcile}
            onChange={onReconcileChange}
            className="h-4 w-4 text-[--color-primary] focus:ring-[--color-primary] border-gray-300 rounded"
          />
          <label
            htmlFor="reconcile"
            className="ml-2 block text-sm text-gray-900"
          >
            Compte lettrable
          </label>
        </div> */}

        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
          <div className="flex">
            <FaExclamationCircle className="text-yellow-400 mt-0.5" size={16} />
            <div className="ml-3">
              <p className="text-sm text-yellow-800">
                <strong>Confirmation requise</strong>
              </p>
              <p className="text-sm text-yellow-700 mt-1">
                Êtes-vous sûr de vouloir créer ce nouveau compte comptable ?
                Cette action ajoutera le compte{" "}
                <strong>{newAccountData.code}</strong> à votre plan comptable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateAccountModal;